/* eslint-disable tailwindcss/no-custom-classname */
import './tameeni-loader.css'

const TameeniLoader = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='132.04365'
      height='129.61825'
      viewBox='0 0 97.803 96.015'
      className='animate-bounce'
    >
      <g
        id='Group_76'
        data-name='Group 76'
        transform='translate(-981.705 -922.993)'
      >
        <g
          id='Path_35923'
          data-name='Path 35923'
          transform='translate(983.205 1017.507) rotate(-90)'
        >
          <g
            id='Path_80'
            data-name='Path 80'
            transform='translate(0)'
            fill='#149ade'
            strokeLinecap='square'
          >
            <path
              d='M 46.5074348449707 95.55297088623047 C 40.12579727172852 95.55297088623047 33.9349479675293 94.27907562255859 28.10685920715332 91.76664733886719 C 22.47897148132324 89.34052276611328 17.42508506774902 85.86769866943359 13.08557224273682 81.44461059570313 C 8.747109413146973 77.02261352539063 5.340960025787354 71.87328338623047 2.961759805679321 66.13969421386719 C 0.4988098442554474 60.20428466796875 -0.7500026822090149 53.89984893798828 -0.7500026822090149 47.40148544311523 C -0.7500026822090149 40.90317153930664 0.4988973438739777 34.59872436523438 2.962022304534912 28.66325950622559 C 5.341334819793701 22.92971038818359 8.747622489929199 17.78039741516113 13.08623504638672 13.35834789276123 C 17.42584800720215 8.935297966003418 22.47975921630859 5.462460517883301 28.10759735107422 3.036322832107544 C 33.93559646606445 0.5238979458808899 40.12619781494141 -0.7500020861625671 46.5074348449707 -0.7500020861625671 C 52.8880615234375 -0.7500020861625671 59.07828521728516 0.5238979458808899 64.90615081787109 3.036335468292236 C 70.53392028808594 5.462497711181641 75.58788299560547 8.935322761535645 79.92761993408203 13.35833549499512 C 84.26647186279297 17.78046035766602 87.6729736328125 22.92975997924805 90.05247497558594 28.66323471069336 C 92.51583862304688 34.59879684448242 93.76486968994141 40.90324783325195 93.76486968994141 47.40148544311523 C 93.76486968994141 53.89984893798828 92.51605987548828 60.20428466796875 90.05310821533203 66.13969421386719 C 87.67391204833984 71.87328338623047 84.26776123046875 77.02261352539063 79.92929840087891 81.44461059570313 C 75.58978271484375 85.86769866943359 70.53589630126953 89.34052276611328 64.90801239013672 91.76664733886719 C 59.07992172241211 94.27907562255859 52.88907241821289 95.55297088623047 46.5074348449707 95.55297088623047 Z'
              stroke='none'
              className='lKUxMmjO_0'
            ></path>
            <path
              d='M 46.5074348449707 -7.62939453125e-06 C 20.82176971435547 -7.62939453125e-06 -7.62939453125e-06 21.22245788574219 -7.62939453125e-06 47.40148544311523 C -7.62939453125e-06 73.58049774169922 20.82000732421875 94.80296325683594 46.5074348449707 94.80296325683594 C 72.19486236572266 94.80296325683594 93.01486206054688 73.58049774169922 93.01486206054688 47.40148544311523 C 93.01486206054688 21.22245788574219 72.19043731689453 -7.62939453125e-06 46.5074348449707 -7.62939453125e-06 M 46.5074348449707 -1.500007629394531 C 52.99075317382813 -1.500007629394531 59.28087615966797 -0.2054901123046875 65.20306396484375 2.347602844238281 C 70.92059326171875 4.812461853027344 76.05476379394531 8.340286254882813 80.46296691894531 12.83306884765625 C 84.86930084228516 17.32396697998047 88.32874298095703 22.55326843261719 90.74517059326172 28.37575531005859 C 93.24655151367188 34.40289688110352 94.51486206054688 40.80408477783203 94.51486206054688 47.40148544311523 C 94.51486206054688 53.99899291992188 93.24676513671875 60.40015029907227 90.74581909179688 66.42713928222656 C 88.32968902587891 72.24974060058594 84.87060546875 77.47905731201172 80.46466064453125 81.96985626220703 C 76.05668640136719 86.46271514892578 70.92256927490234 89.99055480957031 65.20491027832031 92.45536804199219 C 59.28251647949219 95.00844573974609 52.99178314208984 96.30296325683594 46.5074348449707 96.30296325683594 C 40.02308654785156 96.30296325683594 33.73235321044922 95.00844573974609 27.80995178222656 92.45536804199219 C 22.09230041503906 89.99055480957031 16.95818328857422 86.46271514892578 12.55020904541016 81.96985626220703 C 8.144248962402344 77.47905731201172 4.685165405273438 72.24974060058594 2.269035339355469 66.42713928222656 C -0.2319107055664063 60.40015029907227 -1.500007629394531 53.99899291992188 -1.500007629394531 47.40148544311523 C -1.500007629394531 40.80401992797852 -0.2318344116210938 34.40284729003906 2.269287109375 28.37579345703125 C 4.685554504394531 22.55324554443359 8.144767761230469 17.32392883300781 12.55087280273438 12.83309936523438 C 16.95893859863281 8.340255737304688 22.09308624267578 4.812431335449219 27.81069183349609 2.34759521484375 C 33.73300933837891 -0.2054901123046875 40.02350234985352 -1.500007629394531 46.5074348449707 -1.500007629394531 Z'
              stroke='none'
              fill='#fff'
              className='lKUxMmjO_1'
            ></path>
          </g>
        </g>
        <g
          id='Path_35923-2'
          data-name='Path 35923'
          transform='translate(988.342 1012.467) rotate(-90)'
        >
          <path
            id='Path_80-2'
            data-name='Path 80'
            d='M41.467,0c22.9,0,41.467,18.922,41.467,42.264S64.371,84.529,41.467,84.529,0,65.606,0,42.264,18.565,0,41.467,0Z'
            transform='translate(0)'
            fill='none'
            stroke='#fff'
            strokeLinecap='round'
            strokeWidth='2'
            className='lKUxMmjO_2'
          ></path>
        </g>
        <g
          id='Group_2182'
          data-name='Group 2182'
          transform='translate(1007.859 940.665)'
        >
          <g
            id='Group_3'
            data-name='Group 3'
            transform='translate(0.01 26.873)'
          >
            <path
              id='Path_10'
              data-name='Path 10'
              d='M391.607,416.848l-19.2,14.208a3.223,3.223,0,0,1-3.858,0l-19.193-14.208a1.239,1.239,0,0,0-1.97,1.006v15.569a5.86,5.86,0,0,0,2.452,4.766l18.38,13.131a3.913,3.913,0,0,0,4.533,0l18.376-13.134a5.9,5.9,0,0,0,2.453-4.766V417.84a1.234,1.234,0,0,0-1.97-.991Zm-3.073,14.944a3.784,3.784,0,0,1-1.516,3.2L372.953,445.75a4.113,4.113,0,0,1-4.946,0l-14.439-10.94a1.892,1.892,0,0,1-.413-.345,3.5,3.5,0,0,1-.95-1.953,2.735,2.735,0,0,1-.069-.565l.041-4.478a.993.993,0,0,1,1.571-.813l14.866,10.664a3.186,3.186,0,0,0,3.719,0L387.1,426.711a.9.9,0,0,1,1.433.73Z'
              transform='translate(-347.383 -416.604)'
              fill='none'
              stroke='#fff'
              strokeLinecap='round'
              strokeWidth='2'
              className='lKUxMmjO_3'
            ></path>
          </g>
          <path
            id='Path_13'
            data-name='Path 13'
            d='M348.71,416.968h2.2a1.285,1.285,0,0,0,1.285-1.288l-.02-7.006a2.871,2.871,0,0,1,2.852-2.877l6.929-.041a8.951,8.951,0,0,0,4.557-1.278l3.191-1.94a1.362,1.362,0,0,1,1.533-.014l3.53,2.218a7.245,7.245,0,0,0,3.97,1l6.872-.051c1.6,0,2.977.87,2.977,2.551l.027,5.779a2.337,2.337,0,0,1-.983,1.97L371.305,428.01a2.621,2.621,0,0,0-1.081,2.12v3.516a.919.919,0,0,0,1.447.752l20.886-15.256a2.28,2.28,0,0,0,1.03-2.138s-.01-9.349-.01-9.6v-2.841a3.354,3.354,0,0,0-3.355-3.355H379.129a5.091,5.091,0,0,1-2.715-.781l-4.7-2.965a2.325,2.325,0,0,0-2.477,0l-4.435,2.8a6.159,6.159,0,0,1-3.289.95H351.027a3.653,3.653,0,0,0-3.652,3.653v10.775a1.334,1.334,0,0,0,1.335,1.327Z'
            transform='translate(-347.375 -397.099)'
            fill='none'
            stroke='#fff'
            strokeLinecap='round'
            strokeWidth='2'
            className='lKUxMmjO_4'
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default TameeniLoader
